import React, { useState } from "react";
import { QueryClientProvider } from "@tanstack/react-query";

import { createQueryClient, getQueryClient } from "../api/queryClient";

const QueryProvider = ({ children }) => {
  // The shared client is browser-only. Gatsby's SSR engine renders every
  // request in ONE long-lived process, so a module-singleton QueryClient
  // is shared by all visitors server-side — one request's cached queries
  // can render into another's page. Each server render gets its own
  // client; the browser keeps the singleton so client-side caching and
  // hydration are unchanged.
  const [queryClient] = useState(() =>
    typeof window === "undefined" ? createQueryClient() : getQueryClient(),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default QueryProvider;
